    (function() {
      // Timeout for debouncing sync calls (must be declared before use)
      let syncProductListsTimeout = null;

// Add to cart function - NO drawer opening
      async function addProdToCart(variantId, quantity, blockId, productId) {
        // Kick off cart-drawer script/style load in parallel with the add
        // request. Without this, the first PLP add fires before cart-drawer.js
        // is registered, so `cartDrawerElement.renderContents` is not yet a
        // function and the drawer's contents never refresh — the shake and
        // auto-update only start working once the user opens the drawer
        // manually (which is what triggers the lazy loader today).
        const cartScriptsReady = window.loadCartDrawerScripts
          ? window.loadCartDrawerScripts()
          : Promise.resolve();

        // Check if this is an upsell button
        const buttonElement = document.querySelector('.minimised-grid-buy-btn[data-variant-id="' + variantId + '"][data-block-id="' + blockId + '"]');
        const isUpsell = buttonElement && buttonElement.classList.contains('minimised-grid-upsell-btn');

        // Show loading state on all buttons in this block
        setBlockLoadingState(blockId, true, variantId);

        try {
          // If this is an upsell item, check if it's already in cart before adding
          if (isUpsell) {
            let cartUrl = '/cart.js';
            if (window.MarketCartUtils && window.MarketCartUtils.getMarketAwareCartUrl) {
              cartUrl = window.MarketCartUtils.getMarketAwareCartUrl('/cart.js');
            }

            const checkCartResponse = await fetch(cartUrl);
            if (!checkCartResponse.ok) {
              // Cart check failed - don't proceed with add to prevent duplicates
              setBlockLoadingState(blockId, false);
              return;
            }

            const checkCartData = await checkCartResponse.json();

            // Check if this variant is already in cart with upsell or quantity_restricted properties
            const isAlreadyInCart = checkCartData.items.some(item => {
              if (item.variant_id !== parseInt(variantId) || !item.properties) return false;
              const isQuantityRestricted = item.properties._quantity_restricted === 'true';
              const isUpsellItem = item.properties._upsell_item === 'true';
              const isCheckoutBlockUpsell = item.properties._checkoutblocks && String(item.properties._checkoutblocks).includes('advanced-upsell');
              return isQuantityRestricted || isUpsellItem || isCheckoutBlockUpsell;
            });

            // If already in cart, restore buttons and do nothing
            if (isAlreadyInCart) {
              setBlockLoadingState(blockId, false);
              updateBlockSelectionState(blockId, variantId);
              return;
            }
          }

          if (typeof SLIDECART_UPDATE === "function") SLIDECART_UPDATE();

          // Get cart drawer section ID (same as PDP/PLP)
          const cartDrawer = document.getElementById('cart-drawer');
          let sections = 'cart-icon-bubble';
          if (cartDrawer) {
            const cartDrawerSection = cartDrawer.closest('.shopify-section');
            if (cartDrawerSection) {
              sections += ',' + cartDrawerSection.id.replace('shopify-section-', '');
            }
          }

          // Add properties for upsell items to exclude them from totals (but show in cart)
          const properties = {};
          if (isUpsell) {
            properties._upsell_item = 'true';
          }

          // data-inventory is only a hard limit when the variant denies
          // overselling; otherwise leave it to the server so backorders work.
          const inventoryAvailable = buttonElement && buttonElement.dataset.inventoryTracked === 'true'
            ? parseInt(buttonElement.dataset.inventory, 10)
            : null;

          let data;
          if (window.MarketCartUtils && window.MarketCartUtils.addToCart) {
            // Optimistic badge bump + cart icon shake are handled centrally by
            // MarketCartUtils.addToCart (see market-cart-utils.js), which also
            // serializes the request through the shared mutation queue and runs
            // the inventory guard.
            data = await window.MarketCartUtils.addToCart(variantId, quantity, properties, {
              sections: sections,
              sections_url: window.location.pathname + window.location.search,
              inventoryAvailable: inventoryAvailable
            });

            if (data && data.status && data.status !== 200) {
              let error = typeof data.description === 'string' ? data.description : data.message;
              if (data.errors && typeof data.errors === 'object') {
                error = Object.entries(data.errors).map((item) => item[1].join(', '));
              }
              throw new Error(error || 'Failed to add to cart');
            }
          } else {
            // Fallback to direct fetch - the optimistic feedback above is only
            // centralized when MarketCartUtils is available, so do it here.
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', quantity);
            formData.append('sections_url', window.location.pathname + window.location.search);
            formData.append('sections', sections);

            if (isUpsell) {
              formData.append('properties[_upsell_item]', 'true');
            }

            // Optimistically increment the cart count badge immediately for responsiveness
            // (Header section is rendered multiple times for different markets, so update ALL matching badges.)
            if (!isUpsell) {
              document.querySelectorAll('[id="cart-count-badge"]').forEach((badge) => {
                const countEl = badge.querySelector('.cart-count-number');
                if (countEl) {
                  const currentCount = parseInt(countEl.textContent, 10) || 0;
                  countEl.textContent = currentCount + parseInt(quantity, 10);
                }
                badge.style.visibility = '';
              });
            }

            // Trigger shake immediately on click (before network request) - all header instances
            window.MarketCartUtils?.shakeCartIcon();

            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            });

            data = await response.json();

            if (!response.ok || data.status) {
              let error = typeof data.description === 'string' ? data.description : data.message;
              if (data.errors && typeof data.errors === 'object') {
                error = Object.entries(data.errors).map((item) => item[1].join(', '));
              }
              throw new Error(error);
            }
          }


          // Save selection to localStorage immediately (supports multiple)
          const currentSelections = getSelectedProducts(blockId);
          const isAlreadySelected = currentSelections.some(sel => sel.variantId === variantId);

          if (!isAlreadySelected) {
            currentSelections.push({ productId: productId, variantId: variantId });
            const selectionString = currentSelections.map(sel => sel.productId + '|' + sel.variantId).join(',');
            localStorage.setItem('minimised-grid-selection-' + blockId, selectionString);
          }

          // Update cart icon bubble from sections data (like PDP/PLP)
          if (data.sections && data.sections['cart-icon-bubble']) {
            if (window.MarketCartUtils && window.MarketCartUtils.updateCartIconBubble) {
              window.MarketCartUtils.updateCartIconBubble(data.sections['cart-icon-bubble']);
            }
          }

          // Update checkout button immediately with cart data from response
          if (data && data.items !== undefined) {
            updateCheckoutButton(data);
          } else {
            updateCheckoutButton();
          }

          // Immediately update cart drawer with sections data from response (like PDP/PLP does)
          // This ensures cart drawer shows items immediately when opened.
          // On the first PLP add the cart-drawer custom element may not have
          // been upgraded yet (its script is lazy-loaded), so wait for the
          // preload kicked off at the top of this function before calling
          // renderContents.
          const cartDrawerElement = document.getElementById('cart-drawer');
          if (cartDrawerElement && data.sections) {
            cartScriptsReady
              .then(() => {
                if (typeof cartDrawerElement.renderContents === 'function') {
                  return cartDrawerElement.renderContents(data, false);
                }
              })
              .catch(error => {
                console.error('Error updating cart drawer with sections data:', error);
              });
          }

          // Fetch fresh cart data once and dispatch events for all components
          try {
            const cartResponse = await fetch('/cart.js');
            if (cartResponse.ok) {
              const cartData = await cartResponse.json();

              // Update MarketCartUtils event cache first so other components can use it
              if (window.MarketCartUtils && window.MarketCartUtils.setEventCartData) {
                window.MarketCartUtils.setEventCartData(cartData);
              }

              // Dispatch on:cart:add event for new items (progress bar listens to this)
              document.dispatchEvent(new CustomEvent('on:cart:add', {
                bubbles: true,
                detail: {
                  cart: cartData,
                  variantId: variantId
                }
              }));

              // Also dispatch cart:updated for other components (single event, not multiple)
              document.dispatchEvent(new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { cart: cartData }
              }));
            }
          } catch (error) {
            console.error('Error fetching cart data after add:', error);
          }

          // Update UI state AFTER all operations complete - switches directly from loading to final state
          updateBlockSelectionState(blockId, variantId);

        } catch (error) {
          console.error('Error adding product to cart:', error);
          // The inventory guard blocked the add before anything was sent, so
          // tell the shopper why rather than silently doing nothing.
          if (error && error.name === 'InventoryLimitError') {
            showButtonNotice(buttonElement, error.message);
          }
          // Restore all button states on error
          setBlockLoadingState(blockId, false);
          updateBlockSelectionState(blockId, null);
        }
      }

      /**
       * Show a short inline notice under a grid buy button (used by the
       * inventory guard, which blocks the add rather than overselling).
       */
      function showButtonNotice(buttonElement, message) {
        if (!buttonElement) return;
        const container = buttonElement.parentElement;
        let notice = container.querySelector('.minimised-grid-notice');
        if (!notice) {
          notice = document.createElement('div');
          notice.className = 'minimised-grid-notice';
          notice.setAttribute('role', 'status');
          notice.style.cssText = 'margin-top:4px;font-size:11px;line-height:1.3;color:#b42318;text-align:center;';
          buttonElement.insertAdjacentElement('afterend', notice);
        }
        notice.textContent = message;
        clearTimeout(notice.hideTimer);
        notice.hideTimer = setTimeout(() => notice.remove(), 5000);
      }

      // Get selected products for a block
      function getSelectedProducts(blockId) {
        const savedSelection = localStorage.getItem('minimised-grid-selection-' + blockId);
        if (!savedSelection) return [];

        // Format: "productId1|variantId1,productId2|variantId2,..."
        return savedSelection.split(',').map(item => {
          const [prodId, varId] = item.split('|');
          return { productId: prodId, variantId: varId };
        });
      }

      // Show loading state on all buttons in a block
      // While an add/remove is in flight: the clicked option (variantId) shows a
      // loading spinner, and every OTHER option in the block greys out — mirroring
      // the loyalty step. Other buttons get a dimmed "busy" state, NOT a spinner.
      // When variantId is null (or on clear) the whole block is affected.
      function setBlockLoadingState(blockId, isLoading, variantId = null) {
        const buttons = document.querySelectorAll('.minimised-grid-buy-btn[data-block-id="' + blockId + '"]');
        buttons.forEach(btn => {
          if (!isLoading) {
            btn.disabled = false;
            btn.classList.remove('minimised-grid-btn-loading', 'minimised-grid-btn-busy');
            return;
          }
          btn.disabled = true;
          const isTarget = variantId == null || btn.getAttribute('data-variant-id') === String(variantId);
          if (isTarget) {
            btn.classList.add('minimised-grid-btn-loading');
            btn.classList.remove('minimised-grid-btn-busy');
          } else {
            btn.classList.add('minimised-grid-btn-busy');
            btn.classList.remove('minimised-grid-btn-loading');
          }
        });
      }

      // Update block selection state (supports multiple selections)
      function updateBlockSelectionState(blockId, selectedVariantId) {
        const buttons = document.querySelectorAll('.minimised-grid-buy-btn[data-block-id="' + blockId + '"]');
        const firstButton = buttons[0];
        if (!firstButton) return;

        const maxSelections = parseInt(firstButton.getAttribute('data-max-selections'), 10) || 1;
        const selectedProducts = getSelectedProducts(blockId);

        // Check if this is a base-can block
        const firstCard = firstButton.closest('.minimised-grid-product-card');
        const isBaseCan = firstCard && firstCard.getAttribute('data-block-type') === 'base';
        const allowMultiple = isBaseCan ? true : (maxSelections > 1);

        var removeLabel = (window.__minimisedGridTranslations && window.__minimisedGridTranslations.remove) || 'Remove';

        buttons.forEach(btn => {
          const variantId = btn.getAttribute('data-variant-id');
          const originalPrice = btn.getAttribute('data-original-price');
          const isThisSelected = selectedProducts.some(sel => sel.variantId === variantId);

          // Always clear loading/busy state when updating
          btn.classList.remove('minimised-grid-btn-loading', 'minimised-grid-btn-busy');

          if (isThisSelected) {
            // Selected button — keep price visible in buyo buttons
            var textEl = btn.querySelector('.mgrid-btn-text');
            var isBuyoBtn = btn.classList.contains('mgrid-buyo__btn');
            if (isBuyoBtn && textEl) {
              // Keep the price text, don't replace with "Remove"
            } else if (textEl) {
              textEl.textContent = removeLabel;
            } else {
              btn.textContent = removeLabel;
            }
            btn.classList.add('minimised-grid-btn-selected');
            btn.disabled = false;
          } else {
            // Other buttons
            var textEl = btn.querySelector('.mgrid-btn-text');
            if (textEl) textEl.textContent = originalPrice; else btn.textContent = originalPrice;
            btn.classList.remove('minimised-grid-btn-selected');

            if (isBaseCan) {
              // Base cans: capacity handled by updateBaseCansCapacity after this
            } else if (allowMultiple) {
              // For multiple selections: disable only if we've reached max selections
              if (selectedProducts.length >= maxSelections) {
                btn.disabled = true;
              } else {
                btn.disabled = false;
              }
            } else {
              // For single selection: disable all other buttons once one is selected
              if (selectedProducts.length > 0) {
                btn.disabled = true;
              } else {
                btn.disabled = false;
              }
            }
          }
        });

        // For base cans, update capacity after selection state
        if (isBaseCan) {
          updateBaseCansCapacity(blockId);
        }
      }

      // Remove from cart (single selection)
      async function removeFromCart(variantId, blockId) {
        const cartScriptsReady = window.loadCartDrawerScripts
          ? window.loadCartDrawerScripts()
          : Promise.resolve();
        // Show loading state on all buttons in this block
        setBlockLoadingState(blockId, true, variantId);

        try {
          // Fetch cart to find the line item key by variant_id
          const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await cartResponse.json();

          // Find the base line item by variant_id (exclude upsell/restricted items - those are handled by removeFromCartMultiple)
          const lineItem = cart.items.find(item => {
            if (String(item.variant_id) !== String(variantId)) return false;
            if (item.properties) {
              const isUpsellItem = item.properties._upsell_item === 'true';
              const isQuantityRestricted = item.properties._quantity_restricted === 'true';
              const isCheckoutBlockUpsell = item.properties._checkoutblocks && String(item.properties._checkoutblocks).includes('advanced-upsell');
              if (isUpsellItem || isQuantityRestricted || isCheckoutBlockUpsell) return false;
            }
            return true;
          });

          if (!lineItem) {
            // Restore buttons if line item not found
            setBlockLoadingState(blockId, false);
            updateBlockSelectionState(blockId, null);
            return;
          }

          // Get cart drawer section ID for sections request (like add function)
          const cartDrawer = document.getElementById('cart-drawer');
          let sections = 'cart-icon-bubble';
          if (cartDrawer) {
            const cartDrawerSection = cartDrawer.closest('.shopify-section');
            if (cartDrawerSection) {
              sections += ',' + cartDrawerSection.id.replace('shopify-section-', '');
            }
          }

          // Use line item key for removal (required when items have properties)
          const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: lineItem.key,
              quantity: 0,
              sections: sections,
              sections_url: window.location.pathname + window.location.search
            })
          });

          const data = await response.json();

          // Clear selection from localStorage immediately
          localStorage.removeItem('minimised-grid-selection-' + blockId);

          // Update checkout button immediately with cart data from response
          if (data && data.items !== undefined) {
            updateCheckoutButton(data);
          } else {
            updateCheckoutButton();
          }

          // Dispatch events with cart data from response (single event for all components)
          if (data && data.items !== undefined) {
            // Update MarketCartUtils event cache first
            if (window.MarketCartUtils && window.MarketCartUtils.setEventCartData) {
              window.MarketCartUtils.setEventCartData(data);
            }

            // Dispatch cart:updated for all components (single event)
            document.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: data }
            }));
          }

          // Update cart icon bubble from sections data
          if (data.sections && data.sections['cart-icon-bubble']) {
            if (window.MarketCartUtils && window.MarketCartUtils.updateCartIconBubble) {
              window.MarketCartUtils.updateCartIconBubble(data.sections['cart-icon-bubble']);
            }
          }

          // Immediately update cart drawer with sections data from response
          const cartDrawerElement = document.getElementById('cart-drawer');
          if (cartDrawerElement && data.sections) {
            cartScriptsReady
              .then(() => {
                if (typeof cartDrawerElement.renderContents === 'function') {
                  return cartDrawerElement.renderContents(data, false);
                }
              })
              .catch(error => {
                console.error('Error updating cart drawer with sections data:', error);
              });
          }

          // Update UI state AFTER all operations complete - switches directly from loading to final state
          updateBlockSelectionState(blockId, null);

        } catch (error) {
          console.error('Error removing from cart:', error);
          // Restore all button states on error
          setBlockLoadingState(blockId, false);
          updateBlockSelectionState(blockId, null);
        }
      }

      // Remove from cart (multiple selections - for upsell)
      async function removeFromCartMultiple(variantId, blockId, productId, maxSelections) {
        const cartScriptsReady = window.loadCartDrawerScripts
          ? window.loadCartDrawerScripts()
          : Promise.resolve();
        // Show loading state on all buttons in this block
        setBlockLoadingState(blockId, true, variantId);

        try {
          // Fetch cart to find the line item key by variant_id
          const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await cartResponse.json();

          // Determine if this is an upsell or base block button
          const buttonElement = document.querySelector('.minimised-grid-buy-btn[data-variant-id="' + variantId + '"][data-block-id="' + blockId + '"]');
          const isUpsell = buttonElement && buttonElement.classList.contains('minimised-grid-upsell-btn');

          // Find the line item by variant_id, filtering based on block type
          const lineItem = cart.items.find(item => {
            if (String(item.variant_id) !== String(variantId)) return false;
            if (isUpsell) {
              // For upsell items: must have upsell/restricted properties
              if (!item.properties) return false;
              const isUpsellItem = item.properties._upsell_item === 'true';
              const isQuantityRestricted = item.properties._quantity_restricted === 'true';
              const isCheckoutBlockUpsell = item.properties._checkoutblocks && String(item.properties._checkoutblocks).includes('advanced-upsell');
              return isUpsellItem || isQuantityRestricted || isCheckoutBlockUpsell;
            } else {
              // For base items: must NOT have upsell/restricted properties
              if (item.properties) {
                const isUpsellItem = item.properties._upsell_item === 'true';
                const isQuantityRestricted = item.properties._quantity_restricted === 'true';
                const isCheckoutBlockUpsell = item.properties._checkoutblocks && String(item.properties._checkoutblocks).includes('advanced-upsell');
                if (isUpsellItem || isQuantityRestricted || isCheckoutBlockUpsell) return false;
              }
              return true;
            }
          });

          if (!lineItem) {
            // Restore buttons if upsell line item not found
            setBlockLoadingState(blockId, false);
            updateBlockSelectionState(blockId, null);
            return;
          }

          // Get cart drawer section ID for sections request (like add function)
          const cartDrawer = document.getElementById('cart-drawer');
          let sections = 'cart-icon-bubble';
          if (cartDrawer) {
            const cartDrawerSection = cartDrawer.closest('.shopify-section');
            if (cartDrawerSection) {
              sections += ',' + cartDrawerSection.id.replace('shopify-section-', '');
            }
          }

          // Use line item key for removal (required when items have properties)
          const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: lineItem.key,
              quantity: 0,
              sections: sections,
              sections_url: window.location.pathname + window.location.search
            })
          });

          const data = await response.json();

          // Remove this selection from localStorage immediately
          const currentSelections = getSelectedProducts(blockId);
          const updatedSelections = currentSelections.filter(sel => sel.variantId !== variantId);

          if (updatedSelections.length > 0) {
            const selectionString = updatedSelections.map(sel => sel.productId + '|' + sel.variantId).join(',');
            localStorage.setItem('minimised-grid-selection-' + blockId, selectionString);
          } else {
            localStorage.removeItem('minimised-grid-selection-' + blockId);
          }

          // Update checkout button immediately with cart data from response
          if (data && data.items !== undefined) {
            updateCheckoutButton(data);
          } else {
            updateCheckoutButton();
          }

          // Dispatch events with cart data from response (single event for all components)
          if (data && data.items !== undefined) {
            // Update MarketCartUtils event cache first
            if (window.MarketCartUtils && window.MarketCartUtils.setEventCartData) {
              window.MarketCartUtils.setEventCartData(data);
            }

            // Dispatch cart:updated for all components (single event)
            document.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: data }
            }));
          }

          // Update cart icon bubble from sections data
          if (data.sections && data.sections['cart-icon-bubble']) {
            if (window.MarketCartUtils && window.MarketCartUtils.updateCartIconBubble) {
              window.MarketCartUtils.updateCartIconBubble(data.sections['cart-icon-bubble']);
            }
          }

          // Immediately update cart drawer with sections data from response
          const cartDrawerElement = document.getElementById('cart-drawer');
          if (cartDrawerElement && data.sections) {
            cartScriptsReady
              .then(() => {
                if (typeof cartDrawerElement.renderContents === 'function') {
                  return cartDrawerElement.renderContents(data, false);
                }
              })
              .catch(error => {
                console.error('Error updating cart drawer with sections data:', error);
              });
          }

          // Update UI state AFTER all operations complete - switches directly from loading to final state
          updateBlockSelectionState(blockId, variantId);

        } catch (error) {
          console.error('Error removing from cart:', error);
          // Restore all button states on error
          setBlockLoadingState(blockId, false);
          updateBlockSelectionState(blockId, null);
        }
      }

      // Update checkout button state based on cart
      async function updateCheckoutButton(cartData = null) {
        try {
          let cart = cartData;
          if (!cart) {
            const response = await fetch(window.Shopify.routes.root + 'cart.js', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            });
            cart = await response.json();
          }

          // Checkout total: all paid lines (incl. upsells) minus order-level discounts
          let cartTotal = 0;

          cart.items.forEach(item => {
            // Skip free-can bundles
            if (item.properties && item.properties._free_can === 'true' && item.properties._free_can_type === 'bundle_product') {
              return;
            }

            cartTotal += item.final_line_price || item.original_line_price;
          });

          const cartLevelDiscounts = cart.cart_level_discount_applications || [];
          cartLevelDiscounts.forEach(discount => {
            cartTotal -= Number(discount.total_allocated_amount) || 0;
          });
          cartTotal = Math.max(0, cartTotal);

          // Check if there are base items (paid items) or upsell items for checkout eligibility
          // Checkout should be disabled if only free cans (loyalty items) are present
          let hasBaseItems = false;
          let hasUpsellItems = false;

          cart.items.forEach(item => {
            const isFreeCan = item.properties && (item.properties._free_can === 'true');
            const isUpsell = item.properties && (item.properties._upsell_item === 'true');
            const isCheckoutBlockUpsell = item.properties && item.properties._checkoutblocks && String(item.properties._checkoutblocks).includes('advanced-upsell');

            if (!isFreeCan && !isUpsell && !isCheckoutBlockUpsell) {
              hasBaseItems = true;
            }
            if (isUpsell || isCheckoutBlockUpsell) {
              hasUpsellItems = true;
            }
          });

          const canCheckout = hasBaseItems || hasUpsellItems;

          // Check if required selections are made from base and upsell blocks
          let hasBaseSelection = false;
          let hasRequiredUpsellSelections = true; // Assume true until we check

          // Check base block selection (min-base-cans)
          const baseButtons = document.querySelectorAll('.minimised-grid-buy-btn:not(.minimised-grid-upsell-btn)');
          const baseBlockIds = new Set();
          baseButtons.forEach(btn => {
            const blockId = btn.getAttribute('data-block-id');
            if (blockId) baseBlockIds.add(blockId);
          });

          baseBlockIds.forEach(blockId => {
            const selections = getSelectedProducts(blockId);
            if (selections.length > 0) {
              hasBaseSelection = true;
            }
          });

          // Check upsell block selections (min-upsell-cans)
          const upsellButtons = document.querySelectorAll('.minimised-grid-upsell-btn');
          const upsellBlockIds = new Set();
          upsellButtons.forEach(btn => {
            const blockId = btn.getAttribute('data-block-id');
            if (blockId) upsellBlockIds.add(blockId);
          });

          upsellBlockIds.forEach(blockId => {
            const selections = getSelectedProducts(blockId);
            const firstButton = document.querySelector('.minimised-grid-upsell-btn[data-block-id="' + blockId + '"]');
            if (firstButton) {
              const maxSelections = parseInt(firstButton.getAttribute('data-max-selections'), 10) || 1;
              if (selections.length < maxSelections) {
                hasRequiredUpsellSelections = false;
              }
            }
          });

          // Update checkout button - enable only if there are base items or upsell items
          const checkoutButton = document.querySelector('.minimised-collection-grid__checkout-button');
          if (checkoutButton) {
            if (canCheckout) {
              checkoutButton.classList.remove('minimised-collection-grid__checkout-button--disabled');
              checkoutButton.removeAttribute('onclick');
            } else {
              checkoutButton.classList.add('minimised-collection-grid__checkout-button--disabled');
              checkoutButton.setAttribute('onclick', 'return false;');
            }

            // Update total display if needed
            if (checkoutButton.hasAttribute('data-cart-total')) {
              // Format price (cart total is in cents)
              const formattedTotal = (cartTotal / 100).toFixed(2);
              checkoutButton.setAttribute('data-cart-total', formattedTotal);
            }
          }
        } catch (error) {
          console.error('Error updating checkout button:', error);
        }
      }

      // Restore selection state on page load
      function restoreSelectionStates() {
        // Find all blocks with buy buttons
        const blockIds = new Set();
        document.querySelectorAll('.minimised-grid-buy-btn[data-block-id]').forEach(btn => {
          blockIds.add(btn.getAttribute('data-block-id'));
        });

        blockIds.forEach(blockId => {
          const savedSelection = localStorage.getItem('minimised-grid-selection-' + blockId);
          if (savedSelection) {
            updateBlockSelectionState(blockId, null);
          }
        });
      }

      // Run on page load
      restoreSelectionStates();
      updateCheckoutButton();


      // Apply strength, brand, and flavour filters to products
      function applyStrengthFilters(blockId) {
        const filterButtons = document.querySelectorAll('.minimised-grid-filter-btn[data-block-id="' + blockId + '"]');
        const activeFilters = Array.from(filterButtons).filter(btn => btn.classList.contains('active')).map(btn => btn.getAttribute('data-filter'));
        const productCards = document.querySelectorAll('.minimised-grid-product-card[data-block-id="' + blockId + '"]');

        // Get strength filters (excluding "Selected", brand filters, and flavour filters)
        const strengthFilters = activeFilters.filter(filter => filter !== 'selected' && !filter.startsWith('brand-') && !filter.startsWith('flavour-'));

        // Get brand filters
        const brandFilters = activeFilters.filter(filter => filter.startsWith('brand-'));

        // Get flavour filters
        const flavourFilters = activeFilters.filter(filter => filter.startsWith('flavour-'));

        // If no filters active, show all items
        if (activeFilters.length === 0) {
          productCards.forEach(card => {
            card.style.display = '';
          });
          return;
        }

        // Track which brands, strengths, and flavours are available in visible products
        const availableBrands = new Set();
        const availableStrengths = new Set();
        const availableFlavours = new Set();

        productCards.forEach(card => {
          // Split comma-separated values to support multi-value matching
          const strengths = (card.getAttribute('data-strength') || '').toLowerCase().trim().split(',').map(s => s.trim()).filter(Boolean);
          const brand = (card.getAttribute('data-brand') || '').trim();
          const flavours = (card.getAttribute('data-flavour') || '').trim().split(',').map(s => s.trim()).filter(Boolean);

          // Strength match: if no strength filters active, treat as pass
          // A product passes if ANY of its strengths match ANY active strength filter
          const hasStrengthFilter = strengthFilters.length > 0;
          const strengthPass = hasStrengthFilter ? strengthFilters.some(filter => strengths.includes(filter.toLowerCase().trim())) : true;

          // Brand match: if no brand filters active, treat as pass
          const hasBrandFilter = brandFilters.length > 0;
          const brandPass = hasBrandFilter ? brandFilters.some(filter => filter.trim() === brand) : true;

          // Flavour match: if no flavour filters active, treat as pass
          // A product passes if ANY of its flavours match ANY active flavour filter
          const hasFlavourFilter = flavourFilters.length > 0;
          const flavourPass = hasFlavourFilter ? flavourFilters.some(filter => flavours.includes(filter.trim())) : true;

          // For "selected" filter, we'll show all for now (cart has quantity logic we don't have here)
          const selectedPass = true;

          // Determine if this card should be shown based on filter logic
          // Card must pass strength AND brand AND flavour filters (if any are active)
          const shouldShow = strengthPass && brandPass && flavourPass && selectedPass;

          // Show/hide card based on filter logic
          if (shouldShow) {
            card.style.display = '';
            // Remove hidden attribute when showing via filter
            card.removeAttribute('hidden');
            // Track available brands, strengths, and flavours from visible products
            if (brand) availableBrands.add(brand);
            strengths.forEach(s => { if (s) availableStrengths.add(s); });
            flavours.forEach(f => { if (f) availableFlavours.add(f); });
          } else {
            card.style.display = 'none';
          }
        });
      }

      // Handle buy button clicks
      document.addEventListener('click', function(event) {
        const button = event.target.closest('.minimised-grid-buy-btn');
        if (button) {
          event.preventDefault();

          const variantId = button.getAttribute('data-variant-id');
          const productId = button.getAttribute('data-product-id');
          const blockId = button.getAttribute('data-block-id');
          const quantity = parseInt(button.getAttribute('data-quantity'), 10) || 1;
          const isSelected = button.classList.contains('minimised-grid-btn-selected');
          const maxSelections = parseInt(button.getAttribute('data-max-selections'), 10) || 1;

          // Check if this is a base-can block (uses cans-based capacity)
          const card = button.closest('.minimised-grid-product-card');
          const isBaseCan = card && card.getAttribute('data-block-type') === 'base';
          const allowMultiple = isBaseCan ? true : (maxSelections > 1);

          if (isSelected) {
            // Remove from cart
            if (allowMultiple) {
              removeFromCartMultiple(variantId, blockId, productId, maxSelections);
            } else {
              removeFromCart(variantId, blockId);
            }
          } else if (!button.disabled) {
            if (isBaseCan) {
              // Base cans: check total cans capacity
              const maxCans = parseInt(card.getAttribute('data-max-cans'), 10) || 0;
              if (maxCans > 0) {
                const totalUsed = getBlockTotalCans(blockId);
                if (totalUsed + quantity > maxCans) return;
              }
            } else if (allowMultiple) {
              // Upsell blocks: check product selection count
              const currentSelections = getSelectedProducts(blockId);
              if (currentSelections.length >= maxSelections) {
                return; // Already at max
              }
            }
            // Add to cart
            addProdToCart(variantId, quantity, blockId, productId).catch(error => {
              console.error('Error in addProdToCart:', error);
            });
          }
          return;
        }

        // Handle filter button clicks
        const filterBtn = event.target.closest('.minimised-grid-filter-btn');
        if (filterBtn) {
          const blockId = filterBtn.getAttribute('data-block-id');
          const filterWrapper = filterBtn.closest('.filter-btn-wrapper');

          // Toggle the active state
          const isCurrentlyActive = filterBtn.classList.contains('active');

          if (isCurrentlyActive) {
            filterBtn.classList.remove('active');
            filterWrapper.classList.remove('active');
          } else {
            filterBtn.classList.add('active');
            filterWrapper.classList.add('active');
          }

          // Show all items when a filter is clicked (both base/upsell and loyalty items)
          const allItems = document.querySelectorAll('[data-min-grid-item][data-block-id="' + blockId + '"]');
          allItems.forEach(function(item) {
            item.hidden = false;
          });

          // Also show loyalty items (they use data-min-loyalty-item)
          const allLoyaltyItems = document.querySelectorAll('[data-min-loyalty-item][data-block-id="' + blockId + '"]');
          const allMeItems = document.querySelectorAll('[data-min-me-item][data-block-id="' + blockId + '"]');
          allLoyaltyItems.forEach(function(item) {
            item.style.display = '';
          });
          allMeItems.forEach(function(item) {
            item.style.display = '';
          });

          // Apply filters
          applyStrengthFilters(blockId);
          return;
        }

      });

      // Disable/enable all loyalty quantity buttons across all cards
      function setAllLoyaltyButtonsState(disabled) {
        var allLoyaltyBtns = document.querySelectorAll('.minimised-loyalty-card .quantity-btn');
        allLoyaltyBtns.forEach(function(btn) {
          btn.disabled = disabled;
          btn.style.opacity = disabled ? '0.3' : '';
          btn.style.cursor = disabled ? 'not-allowed' : '';
          btn.style.background = disabled ? '#f0f0f0' : '';
          btn.style.borderColor = disabled ? '#E4E4E4' : '';
        });
      }

      // Initialize loyalty products to sync with cart drawer
      function initLoyaltyProducts() {
        const cartDrawer = document.getElementById('cart-drawer');
        if (!cartDrawer) return;

        // Get all loyalty product cards
        const loyaltyCards = document.querySelectorAll('.minimised-loyalty-card');

        loyaltyCards.forEach(card => {
          // Skip cards already initialized (prevents duplicate event listeners on pagination)
          if (card.dataset.loyaltyInitialized === 'true') return;
          card.dataset.loyaltyInitialized = 'true';

          const productId = card.dataset.productId;
          const plusBtn = card.querySelector('.quantity-btn[data-action="increase"]');
          const minusBtn = card.querySelector('.quantity-btn[data-action="decrease"]');
          const quantityDisplay = card.querySelector('.quantity-display');

          if (!productId || !plusBtn || !minusBtn || !quantityDisplay) return;

          // Handle plus button clicks
          plusBtn.addEventListener('click', async function() {
            if (plusBtn.disabled || card.classList.contains('loyalty-card-loading')) return;

            // Trigger cart drawer's add function
            if (cartDrawer.addBundleProductToCart) {
              // Show loading indicator on this row and grey out all loyalty buttons
              card.classList.add('loyalty-card-loading');
              setAllLoyaltyButtonsState(true);
              try {
                await cartDrawer.addBundleProductToCart(productId, 1);
                // Update display
                const newQty = parseInt(quantityDisplay.textContent) + 1;
                quantityDisplay.textContent = newQty;
                if (newQty > 0) {
                  minusBtn.style.display = 'flex';
                }
                card.setAttribute('data-quantity', newQty.toString());

                // Update heading after adding
                updateLoyaltyHeading();
              } catch (error) {
                console.error('Error adding loyalty product:', error);
              } finally {
                card.classList.remove('loyalty-card-loading');
                setAllLoyaltyButtonsState(false);
              }
            }
          });

          // Handle minus button clicks
          minusBtn.addEventListener('click', async function() {
            if (minusBtn.disabled || card.classList.contains('loyalty-card-loading')) return;

            const currentQty = parseInt(quantityDisplay.textContent);
            if (currentQty <= 0) return;

            // Trigger cart drawer's remove function
            if (cartDrawer.removeBundleProductFromCart) {
              // Show loading indicator on this row and grey out all loyalty buttons
              card.classList.add('loyalty-card-loading');
              setAllLoyaltyButtonsState(true);
              try {
                await cartDrawer.removeBundleProductFromCart(productId, 1);
                // Update display
                const newQty = currentQty - 1;
                quantityDisplay.textContent = newQty;
                if (newQty === 0) {
                  minusBtn.style.display = 'none';
                }
                card.setAttribute('data-quantity', newQty.toString());

                // Update heading after removing
                updateLoyaltyHeading();
              } catch (error) {
                console.error('Error removing loyalty product:', error);
              } finally {
                card.classList.remove('loyalty-card-loading');
                setAllLoyaltyButtonsState(false);
              }
            }
          });
        });
      }

      // Update a single loyalty card's quantity display from cart data
      function updateLoyaltyCardFromCart(card, cart) {
        const bundleVariantId = card.dataset.bundleVariantId ? Number(card.dataset.bundleVariantId) : null;
        const quantityDisplay = card.querySelector('.quantity-display');
        const minusBtn = card.querySelector('.quantity-btn[data-action="decrease"]');

        if (!bundleVariantId || !quantityDisplay || !minusBtn) {
          return;
        }

        let quantity = 0;

        // Match by bundle variant ID AND free can property (same as cart drawer)
        cart.items.forEach(item => {
          const isFreeCan = item.properties && item.properties._free_can === 'true';
          const itemVariantId = Number(item.variant_id);

          if (isFreeCan && itemVariantId === bundleVariantId) {
            quantity += Number(item.quantity) || 0;
          }
        });

        quantityDisplay.textContent = quantity;
        card.setAttribute('data-quantity', quantity.toString());
        if (quantity > 0) {
          minusBtn.style.display = 'flex';
        } else {
          minusBtn.style.display = 'none';
        }
      }

      // Grey out loyalty cards when max free cans is reached (mirrors cart drawer free cans tab)
      function updateLoyaltyCardOpacity(cart) {
        const stepAfters = document.querySelectorAll('.minimised-loyalty-dynamic-step-after');
        stepAfters.forEach(stepAfter => {
          const blockId = stepAfter.dataset.blockId;
          const maxFreeCans = parseInt(stepAfter.dataset.maxFreeCans, 10) || 0;
          if (maxFreeCans <= 0) return;

          let usedCans = 0;
          if (cart && cart.items) {
            cart.items.forEach(item => {
              const isFreeCan = item.properties && item.properties._free_can === 'true' &&
                                item.properties._free_can_type === 'bundle_product';
              if (isFreeCan) usedCans += Number(item.quantity) || 0;
            });
          }
          const remaining = Math.max(0, maxFreeCans - usedCans);

          const cards = document.querySelectorAll(
            '.minimised-loyalty-card[data-block-id="' + blockId + '"]'
          );
          cards.forEach(card => {
            const qtyEl = card.querySelector('.quantity-display');
            const qty = parseInt(qtyEl?.textContent || '0', 10) || 0;
            const isLoading = card.classList.contains('loyalty-card-loading');
            const plusBtn = card.querySelector('.quantity-btn[data-action="increase"]');

            if (remaining === 0 && qty === 0) {
              card.style.opacity = '0.5';
              if (qtyEl && !isLoading) qtyEl.style.visibility = 'hidden';
            } else {
              card.style.opacity = '1';
              if (qtyEl && !isLoading) qtyEl.style.visibility = 'visible';
            }

            if (plusBtn) {
              if (remaining === 0) {
                plusBtn.style.background = '#f0f0f0';
                plusBtn.style.borderColor = '#E4E4E4';
                plusBtn.style.cursor = 'not-allowed';
                plusBtn.disabled = true;
              } else {
                plusBtn.style.background = '';
                plusBtn.style.borderColor = '';
                plusBtn.style.cursor = '';
                plusBtn.disabled = false;
              }
            }
          });
        });
      }

      function isPapaCartLine(item) {
        if (window.MarketCartUtils && window.MarketCartUtils.isPapaLine) {
          return window.MarketCartUtils.isPapaLine(item);
        }
        return !!item && item.vendor === 'PAP';
      }

      function getMcgMaxPapaPoints() {
        const drawer = document.getElementById('cart-drawer');
        if (drawer) {
          const fromDrawer = Number(drawer.getAttribute('data-max-papa-points'));
          if (!Number.isNaN(fromDrawer) && fromDrawer > 0) return fromDrawer;
        }
        const stepAfter = document.querySelector('.minimised-me-dynamic-step-after');
        if (stepAfter) {
          const fromStep = Number(stepAfter.dataset.maxPapaPoints);
          if (!Number.isNaN(fromStep)) return fromStep;
        }
        return 0;
      }

      function computePapaPointsSpent(cart) {
        let spent = 0;
        if (!cart || !Array.isArray(cart.items)) return spent;
        cart.items.forEach(function(item) {
          if (isPapaCartLine(item)) {
            spent += Number(item.final_line_price) || 0;
          }
        });
        return spent;
      }

      function setAllMeButtonsState(disabled) {
        var allMeBtns = document.querySelectorAll('.minimised-me-card .quantity-btn');
        allMeBtns.forEach(function(btn) {
          btn.disabled = disabled;
          btn.style.opacity = disabled ? '0.3' : '';
          btn.style.cursor = disabled ? 'not-allowed' : '';
          btn.style.background = disabled ? '#f0f0f0' : '';
          btn.style.borderColor = disabled ? '#E4E4E4' : '';
        });
      }

      async function addMeProductFromMcg(productId) {
        const card = document.querySelector('.minimised-me-card[data-product-id="' + productId + '"]');
        if (!card) throw new Error('Member exclusive card not found');

        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && cartDrawer.querySelector && cartDrawer.querySelector('.product-card[data-product-id="' + productId + '"]') &&
            typeof cartDrawer.addMemberExclusiveToCart === 'function') {
          return cartDrawer.addMemberExclusiveToCart(productId, 1, true);
        }

        const pointCost = Number(card.dataset.pointCost) || 0;
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await response.json();
        const maxPoints = getMcgMaxPapaPoints();
        const available = Math.max(0, maxPoints - computePapaPointsSpent(cart));
        if (pointCost > available) {
          throw new Error('Cannot add member exclusive item. Only ' + available + ' points remaining.');
        }

        const variantIdRaw = card.dataset.bundleVariantId;
        if (!variantIdRaw || !/^\d+$/.test(String(variantIdRaw))) {
          throw new Error('Missing member exclusive variant id for product ' + productId);
        }
        const variantId = parseInt(String(variantIdRaw), 10);

        if (window.MarketCartUtils && window.MarketCartUtils.addToCart) {
          await window.MarketCartUtils.addToCart(variantId, 1, {});
        } else {
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('Failed to add to cart');
        }

        const freshResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const freshCart = await freshResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { action: 'add', productId, variantId, quantity: 1, isMemberExclusive: true, cart: freshCart }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: freshCart } }));
      }

      async function removeMeProductFromMcg(productId) {
        const card = document.querySelector('.minimised-me-card[data-product-id="' + productId + '"]');
        if (!card) return;

        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && cartDrawer.querySelector && cartDrawer.querySelector('.product-card[data-product-id="' + productId + '"]') &&
            typeof cartDrawer.removeBundleProductFromCart === 'function') {
          return cartDrawer.removeBundleProductFromCart(productId, 1);
        }

        const variantId = parseInt(String(card.dataset.bundleVariantId), 10);
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await response.json();
        const items = Array.isArray(cart.items) ? cart.items : [];
        const papLines = items.filter(function(i) {
          return Number(i.variant_id) === variantId && isPapaCartLine(i);
        });
        if (papLines.length === 0) return;

        papLines.sort(function(a, b) { return (b.id || 0) - (a.id || 0); });
        const itemToReduce = papLines[0];
        const newQuantity = Math.max(0, (Number(itemToReduce.quantity) || 1) - 1);
        const itemId = itemToReduce.key || parseInt(itemToReduce.id, 10);

        if (window.MarketCartUtils && window.MarketCartUtils.changeCartItem) {
          await window.MarketCartUtils.changeCartItem(itemId, newQuantity);
        } else {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: itemId, quantity: newQuantity })
          });
          if (!res.ok) throw new Error('Failed to update cart');
        }

        const freshResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const freshCart = await freshResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { action: 'remove', productId, variantId, quantity: 1, isMemberExclusive: true, cart: freshCart }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: freshCart } }));
      }

      function initMemberExclusiveProducts() {
        const meCards = document.querySelectorAll('.minimised-me-card');

        meCards.forEach(function(card) {
          if (card.dataset.meInitialized === 'true') return;
          card.dataset.meInitialized = 'true';

          const productId = card.dataset.productId;
          const plusBtn = card.querySelector('.quantity-btn[data-action="increase"]');
          const minusBtn = card.querySelector('.quantity-btn[data-action="decrease"]');
          const quantityDisplay = card.querySelector('.quantity-display');

          if (!productId || !plusBtn || !minusBtn || !quantityDisplay) return;

          plusBtn.addEventListener('click', async function() {
            if (plusBtn.disabled || card.classList.contains('me-card-loading')) return;

            card.classList.add('me-card-loading');
            setAllMeButtonsState(true);
            try {
              await addMeProductFromMcg(productId);
              const newQty = parseInt(quantityDisplay.textContent, 10) + 1;
              quantityDisplay.textContent = newQty;
              if (newQty > 0) minusBtn.style.display = 'flex';
              card.setAttribute('data-quantity', String(newQty));
            } catch (error) {
              console.error('Error adding member exclusive product:', error);
            } finally {
              card.classList.remove('me-card-loading');
              setAllMeButtonsState(false);
            }
          });

          minusBtn.addEventListener('click', async function() {
            if (minusBtn.disabled || card.classList.contains('me-card-loading')) return;

            const currentQty = parseInt(quantityDisplay.textContent, 10) || 0;
            if (currentQty <= 0) return;

            card.classList.add('me-card-loading');
            setAllMeButtonsState(true);
            try {
              await removeMeProductFromMcg(productId);
              const newQty = currentQty - 1;
              quantityDisplay.textContent = newQty;
              if (newQty === 0) minusBtn.style.display = 'none';
              card.setAttribute('data-quantity', String(newQty));
            } catch (error) {
              console.error('Error removing member exclusive product:', error);
            } finally {
              card.classList.remove('me-card-loading');
              setAllMeButtonsState(false);
            }
          });
        });
      }

      function updateMeCardFromCart(card, cart) {
        const bundleVariantId = card.dataset.bundleVariantId ? Number(card.dataset.bundleVariantId) : null;
        const quantityDisplay = card.querySelector('.quantity-display');
        const minusBtn = card.querySelector('.quantity-btn[data-action="decrease"]');

        if (!bundleVariantId || !quantityDisplay || !minusBtn) return;

        let quantity = 0;
        if (cart && Array.isArray(cart.items)) {
          cart.items.forEach(function(item) {
            if (Number(item.variant_id) === bundleVariantId && isPapaCartLine(item)) {
              quantity += Number(item.quantity) || 0;
            }
          });
        }

        quantityDisplay.textContent = quantity;
        card.setAttribute('data-quantity', String(quantity));
        minusBtn.style.display = quantity > 0 ? 'flex' : 'none';
      }

      function updateMeCardPlusButtons(cart) {
        const maxPoints = getMcgMaxPapaPoints();
        const spent = computePapaPointsSpent(cart);
        const remaining = Math.max(0, maxPoints - spent);

        document.querySelectorAll('.minimised-me-dynamic-step-after').forEach(function(stepAfter) {
          stepAfter.dataset.pointsRemaining = String(remaining);
          const localeAvailable = stepAfter.dataset.localeAvailable || '%COUNT% points available';
          const localeUsed = stepAfter.dataset.localeUsed || '%COUNT% points used';
          if (remaining === 0 && spent > 0) {
            stepAfter.textContent = localeUsed.replace('%COUNT%', String(spent)).replace(/\*\*/g, '');
          } else {
            stepAfter.textContent = localeAvailable.replace('%COUNT%', String(remaining)).replace(/\*\*/g, '');
          }
        });

        document.querySelectorAll('.minimised-me-card').forEach(function(card) {
          const qtyEl = card.querySelector('.quantity-display');
          const qty = parseInt(qtyEl?.textContent || '0', 10) || 0;
          const pointCost = Number(card.dataset.pointCost) || 0;
          const isLoading = card.classList.contains('me-card-loading');
          const plusBtn = card.querySelector('.quantity-btn[data-action="increase"]');

          if (remaining === 0 && qty === 0) {
            card.style.opacity = '0.5';
            if (qtyEl && !isLoading) qtyEl.style.visibility = 'hidden';
          } else {
            card.style.opacity = '1';
            if (qtyEl && !isLoading) qtyEl.style.visibility = 'visible';
          }

          if (plusBtn) {
            const canAdd = remaining >= pointCost && pointCost > 0;
            plusBtn.disabled = !canAdd;
            plusBtn.style.background = canAdd ? '' : '#f0f0f0';
            plusBtn.style.borderColor = canAdd ? '' : '#E4E4E4';
            plusBtn.style.cursor = canAdd ? '' : 'not-allowed';
          }
        });
      }

      let syncMeCardsTimeout = null;
      function syncAllMeCards(cartData) {
        if (syncMeCardsTimeout) clearTimeout(syncMeCardsTimeout);

        syncMeCardsTimeout = setTimeout(async function() {
          try {
            let cart = cartData;
            if (!cart) {
              const response = await fetch(window.Shopify.routes.root + 'cart.js');
              cart = await response.json();
            }
            document.querySelectorAll('.minimised-me-card').forEach(function(card) {
              updateMeCardFromCart(card, cart);
            });
            updateMeCardPlusButtons(cart);
          } catch (error) {
            console.error('Error syncing member exclusive cards:', error);
          }
        }, 100);
      }

      // Set min-height on items containers to prevent jumping when filtering
      function setItemsContainerMinHeight() {
        // Handle minimised-collection-grid__items containers (base and upsell blocks)
        const itemsContainers = document.querySelectorAll('.minimised-collection-grid__items');
        itemsContainers.forEach(function(container) {
          // Get the visible height (offsetHeight includes padding and borders)
          const visibleHeight = container.offsetHeight;
          // Get the max-height from computed style
          const computedStyle = window.getComputedStyle(container);
          const maxHeight = parseFloat(computedStyle.maxHeight);
          // Use the smaller of visible height or max-height to ensure min-height doesn't exceed max-height
          const minHeight = isNaN(maxHeight) ? visibleHeight : Math.min(visibleHeight, maxHeight);
          // Set min-height to match the visible height (but not exceed max-height)
          container.style.minHeight = minHeight + 'px';
        });

        // Handle product-grid containers (loyalty block)
        const productGrids = document.querySelectorAll('.minimised-loyalty-products .product-grid, .minimised-me-products .product-grid');
        productGrids.forEach(function(container) {
          // Get the visible height (offsetHeight includes padding and borders)
          const visibleHeight = container.offsetHeight;
          // Get the max-height from computed style
          const computedStyle = window.getComputedStyle(container);
          const maxHeight = parseFloat(computedStyle.maxHeight);
          // Use the smaller of visible height or max-height to ensure min-height doesn't exceed max-height
          const minHeight = isNaN(maxHeight) ? visibleHeight : Math.min(visibleHeight, maxHeight);
          // Set min-height to match the visible height (but not exceed max-height)
          container.style.minHeight = minHeight + 'px';
        });
      }

      // Initialize filter row navigation arrows
      function initFilterNavigation() {
        const filterRowNavs = document.querySelectorAll('.filter-row-nav');

        filterRowNavs.forEach(function(nav) {
          const filterRow = nav.querySelector('.filter-row');
          const leftArrow = nav.querySelector('.filter-nav-arrow--left');
          const rightArrow = nav.querySelector('.filter-nav-arrow--right');

          if (!filterRow || !leftArrow || !rightArrow) return;

          // Add pristine state initially
          nav.classList.add('filter-row-nav--pristine');

          // Function to mark edge cards for dimming
          function updateEdgeDimming() {
            const buttons = filterRow.querySelectorAll('.filter-btn-wrapper');
            if (buttons.length === 0) return;

            // Remove all edge-dimmed classes first
            buttons.forEach(function(btn) { btn.classList.remove('edge-dimmed'); });

            // Only apply dimming if pristine
            if (!nav.classList.contains('filter-row-nav--pristine')) return;

            const containerRect = filterRow.getBoundingClientRect();
            const arrowWidth = 28; // Arrow overlay area

            buttons.forEach(function(btn) {
              const btnRect = btn.getBoundingClientRect();
              // Check if button is near the right edge (under right arrow)
              const isNearRightEdge = btnRect.right > containerRect.right - arrowWidth &&
                                      !rightArrow.classList.contains('filter-nav-arrow--hidden');
              // Check if button is near the left edge (under left arrow)
              const isNearLeftEdge = btnRect.left < containerRect.left + arrowWidth &&
                                     !leftArrow.classList.contains('filter-nav-arrow--hidden');

              if (isNearRightEdge || isNearLeftEdge) {
                btn.classList.add('edge-dimmed');
              }
            });
          }

          // Function to remove pristine state and restore opacity
          function removePristineState() {
            nav.classList.remove('filter-row-nav--pristine');
            const buttons = filterRow.querySelectorAll('.filter-btn-wrapper');
            buttons.forEach(function(btn) { btn.classList.remove('edge-dimmed'); });
          }

          // Function to update arrow visibility based on scroll position
          function updateArrowVisibility() {
            const scrollLeft = Math.round(filterRow.scrollLeft);
            const scrollWidth = filterRow.scrollWidth;
            const clientWidth = filterRow.clientWidth;
            const maxScroll = scrollWidth - clientWidth;

            // Show/hide left arrow
            if (scrollLeft > 2) {
              leftArrow.classList.remove('filter-nav-arrow--hidden');
            } else {
              leftArrow.classList.add('filter-nav-arrow--hidden');
            }

            // Show/hide right arrow (hide if scrolled to end or no overflow)
            if (maxScroll > 2 && scrollLeft < maxScroll - 2) {
              rightArrow.classList.remove('filter-nav-arrow--hidden');
            } else {
              rightArrow.classList.add('filter-nav-arrow--hidden');
            }

            // Update edge dimming after arrow visibility changes
            updateEdgeDimming();
          }

          // Function to get the width of one filter button for scrolling
          function getScrollAmount() {
            const firstButton = filterRow.querySelector('.filter-btn-wrapper');
            if (firstButton) {
              // Get button width plus gap (4px)
              return firstButton.offsetWidth + 4;
            }
            return 80; // fallback
          }

          // Left arrow click handler
          leftArrow.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            removePristineState(); // Remove pristine on interaction
            const scrollAmount = getScrollAmount();
            filterRow.scrollLeft = filterRow.scrollLeft - scrollAmount;
            setTimeout(updateArrowVisibility, 50);
          });

          // Right arrow click handler
          rightArrow.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            removePristineState(); // Remove pristine on interaction
            const scrollAmount = getScrollAmount();
            filterRow.scrollLeft = filterRow.scrollLeft + scrollAmount;
            setTimeout(updateArrowVisibility, 50);
          });

          // Listen for scroll events to update arrow visibility and remove pristine state
          filterRow.addEventListener('scroll', function() {
            removePristineState(); // Remove pristine on scroll interaction
            updateArrowVisibility();
          });

          // Initial check on load - hide left, check right
          leftArrow.classList.add('filter-nav-arrow--hidden');
          updateArrowVisibility();

          // Also check after delays in case content is still loading
          setTimeout(updateArrowVisibility, 100);
          setTimeout(updateArrowVisibility, 300);
          setTimeout(updateArrowVisibility, 500);

          // Check on window resize
          window.addEventListener('resize', updateArrowVisibility);
        });
      }

      // Initialize auto-scrolling pagination for MCG loyalty products
      function initMCGLoyaltyPagination() {
        var containers = document.querySelectorAll('.free-cans-products.minimised-loyalty-products[data-collection-handle]');

        containers.forEach(function(container) {
          if (container.dataset.paginationInitialized === 'true') return;
          if (container.dataset.complete === 'true') return;

          container.dataset.paginationInitialized = 'true';

          var productGrid = container.querySelector('.product-grid');
          if (!productGrid) return;

          var collectionHandle = container.dataset.collectionHandle;
          if (!collectionHandle) return;

          var blockId = container.dataset.blockId || '';
          // Start from page 2 since page 1 products are already rendered by the section
          var currentPage = 2;
          var isLoading = false;
          var hasMoreProducts = true;

          var loadingIndicator = container.querySelector('.mcg-loyalty-loading-indicator');

          var loadMoreProducts = async function() {
            if (isLoading || !hasMoreProducts) return;

            isLoading = true;
            if (loadingIndicator) loadingIndicator.style.display = 'block';

            try {
              var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
              var fetchUrl = rootPath + 'collections/' + collectionHandle +
                '?page=' + currentPage +
                '&view=mcg-loyalty-page' +
                '&block_id=' + encodeURIComponent(blockId);

              var response = await fetch(fetchUrl, {
                headers: { 'Accept': 'text/html' }
              });

              if (!response.ok) {
                throw new Error('Failed to fetch products: ' + response.status);
              }

              var html = await response.text();
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');

              var productCards = doc.querySelectorAll('.product-card');
              var hasMorePagesFlag = doc.querySelector('[data-has-more-pages="true"]');
              var hasNoMorePages = doc.querySelector('[data-has-more-pages="false"]');
              var nextCollectionPage = hasMorePagesFlag ? hasMorePagesFlag.dataset.nextCollectionPage : null;

              if (productCards.length > 0) {
                // Deduplicate against existing cards in the DOM
                var existingProductIds = new Set();
                productGrid.querySelectorAll('.product-card').forEach(function(card) {
                  var pid = card.getAttribute('data-product-id');
                  if (pid) existingProductIds.add(pid);
                });

                var fragment = document.createDocumentFragment();
                var newCount = 0;
                productCards.forEach(function(card) {
                  var pid = card.getAttribute('data-product-id');
                  if (!pid || !existingProductIds.has(pid)) {
                    if (pid) existingProductIds.add(pid);
                    var clone = card.cloneNode(true);
                    // Force-stamp the block id since the AJAX template can't reliably
                    // recover query params from canonical_url, leaving data-block-id empty
                    clone.setAttribute('data-block-id', blockId);
                    clone.querySelectorAll('[data-block-id]').forEach(function(el) {
                      el.setAttribute('data-block-id', blockId);
                    });
                    fragment.appendChild(clone);
                    newCount++;
                  }
                });

                if (newCount > 0) {
                  productGrid.appendChild(fragment);

                  // Re-initialize loyalty product event listeners for new cards
                  initLoyaltyProducts();

                  // Sync new cards with cart data
                  syncAllLoyaltyCards();

                  // Re-apply filters if any are active
                  applyStrengthFilters(blockId);
                }
              }

              // Decide whether to continue
              if (hasNoMorePages || !nextCollectionPage) {
                hasMoreProducts = false;
                container.dataset.complete = 'true';
              } else {
                currentPage = parseInt(nextCollectionPage);
                // Auto-load next page
                setTimeout(function() {
                  if (hasMoreProducts && !isLoading) loadMoreProducts();
                }, 300);
              }
            } catch (error) {
              console.error('[MCG Loyalty Pagination] Error loading products:', error);
              hasMoreProducts = false;
              container.dataset.complete = 'true';
            } finally {
              isLoading = false;
              if (loadingIndicator) loadingIndicator.style.display = 'none';
            }
          };

          // Start auto-loading after a short delay
          setTimeout(function() {
            if (hasMoreProducts && !isLoading) {
              loadMoreProducts();
            }
          }, 500);
        });
      }

      // Initialize auto-scrolling pagination for MCG base products
      function initMCGBasePagination() {
        var containers = document.querySelectorAll('.mcg-base-products[data-collection-handle]');

        containers.forEach(function(container) {
          if (container.dataset.paginationInitialized === 'true') return;
          if (container.dataset.complete === 'true') return;

          container.dataset.paginationInitialized = 'true';

          var collectionHandle = container.dataset.collectionHandle;
          if (!collectionHandle) return;

          var blockId = container.dataset.blockId || '';
          var buttonQuantity = container.dataset.buttonQuantity || '10';
          var maxSelections = container.dataset.maxSelections || '1';
          var currentPage = 2;
          var isLoading = false;
          var hasMoreProducts = true;

          var loadingIndicator = container.querySelector('.mcg-base-loading-indicator');

          var loadMoreProducts = async function() {
            if (isLoading || !hasMoreProducts) return;

            isLoading = true;
            if (loadingIndicator) loadingIndicator.style.display = 'block';

            try {
              var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
              var fetchUrl = rootPath + 'collections/' + collectionHandle +
                '?page=' + currentPage +
                '&view=mcg-base-page' +
                '&block_id=' + encodeURIComponent(blockId) +
                '&button_quantity=' + encodeURIComponent(buttonQuantity) +
                '&max_selections=' + encodeURIComponent(maxSelections);

              var response = await fetch(fetchUrl, {
                headers: { 'Accept': 'text/html' }
              });

              if (!response.ok) {
                throw new Error('Failed to fetch products: ' + response.status);
              }

              var html = await response.text();
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');

              var productCards = doc.querySelectorAll('.minimised-grid-product-card');
              var hasMorePagesFlag = doc.querySelector('[data-has-more-pages="true"]');
              var hasNoMorePages = doc.querySelector('[data-has-more-pages="false"]');
              var nextCollectionPage = hasMorePagesFlag ? hasMorePagesFlag.dataset.nextCollectionPage : null;

              if (productCards.length > 0) {
                // Deduplicate against existing cards by variant ID
                var existingVariantIds = new Set();
                container.querySelectorAll('.minimised-grid-product-card').forEach(function(card) {
                  var vid = card.getAttribute('data-variant-id');
                  if (vid) existingVariantIds.add(vid);
                });

                var fragment = document.createDocumentFragment();
                var newCount = 0;
                productCards.forEach(function(card) {
                  var vid = card.getAttribute('data-variant-id');
                  if (!vid || !existingVariantIds.has(vid)) {
                    if (vid) existingVariantIds.add(vid);
                    var clone = card.cloneNode(true);
                    clone.setAttribute('data-block-id', blockId);
                    clone.querySelectorAll('[data-block-id]').forEach(function(el) {
                      el.setAttribute('data-block-id', blockId);
                    });
                    // AJAX view can't read query params from canonical_url, so inherit the section limit
                    clone.querySelectorAll('[data-max-selections]').forEach(function(el) {
                      el.setAttribute('data-max-selections', maxSelections);
                    });
                    fragment.appendChild(clone);
                    newCount++;
                  }
                });

                if (newCount > 0) {
                  container.appendChild(fragment);
                  syncProductListsWithCart();
                  applyStrengthFilters(blockId);
                  setItemsContainerMinHeight();
                }
              }

              // Decide whether to continue
              if (hasNoMorePages || !nextCollectionPage) {
                hasMoreProducts = false;
                container.dataset.complete = 'true';
              } else {
                currentPage = parseInt(nextCollectionPage);
                setTimeout(function() {
                  if (hasMoreProducts && !isLoading) loadMoreProducts();
                }, 300);
              }
            } catch (error) {
              console.error('[MCG Base Pagination] Error loading products:', error);
              hasMoreProducts = false;
              container.dataset.complete = 'true';
            } finally {
              isLoading = false;
              if (loadingIndicator) loadingIndicator.style.display = 'none';
            }
          };

          setTimeout(function() {
            if (hasMoreProducts && !isLoading) {
              loadMoreProducts();
            }
          }, 500);
        });
      }

      // Initialize auto-scrolling pagination for MCG upsell products
      function initMCGUpsellPagination() {
        var containers = document.querySelectorAll('.mcg-upsell-products[data-collection-handle]');

        containers.forEach(function(container) {
          if (container.dataset.paginationInitialized === 'true') return;
          if (container.dataset.complete === 'true') return;

          container.dataset.paginationInitialized = 'true';

          var collectionHandle = container.dataset.collectionHandle;
          if (!collectionHandle) return;

          var blockId = container.dataset.blockId || '';
          var maxSelections = container.dataset.maxSelections || '3';
          var currentPage = 2;
          var isLoading = false;
          var hasMoreProducts = true;

          var loadingIndicator = container.querySelector('.mcg-upsell-loading-indicator');

          var loadMoreProducts = async function() {
            if (isLoading || !hasMoreProducts) return;

            isLoading = true;
            if (loadingIndicator) loadingIndicator.style.display = 'block';

            try {
              var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
              var fetchUrl = rootPath + 'collections/' + collectionHandle +
                '?page=' + currentPage +
                '&view=mcg-upsell-page' +
                '&block_id=' + encodeURIComponent(blockId) +
                '&max_selections=' + encodeURIComponent(maxSelections);

              var response = await fetch(fetchUrl, {
                headers: { 'Accept': 'text/html' }
              });

              if (!response.ok) {
                throw new Error('Failed to fetch products: ' + response.status);
              }

              var html = await response.text();
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');

              var productCards = doc.querySelectorAll('.minimised-grid-product-card');
              var hasMorePagesFlag = doc.querySelector('[data-has-more-pages="true"]');
              var hasNoMorePages = doc.querySelector('[data-has-more-pages="false"]');
              var nextCollectionPage = hasMorePagesFlag ? hasMorePagesFlag.dataset.nextCollectionPage : null;

              if (productCards.length > 0) {
                // Deduplicate against existing cards by product ID
                var existingProductIds = new Set();
                container.querySelectorAll('.minimised-grid-product-card').forEach(function(card) {
                  var pid = card.getAttribute('data-product-id');
                  if (pid) existingProductIds.add(pid);
                });

                var fragment = document.createDocumentFragment();
                var newCount = 0;
                productCards.forEach(function(card) {
                  var pid = card.getAttribute('data-product-id');
                  if (!pid || !existingProductIds.has(pid)) {
                    if (pid) existingProductIds.add(pid);
                    var clone = card.cloneNode(true);
                    clone.setAttribute('data-block-id', blockId);
                    clone.querySelectorAll('[data-block-id]').forEach(function(el) {
                      el.setAttribute('data-block-id', blockId);
                    });
                    // AJAX view can't read query params from canonical_url, so inherit the section limit
                    clone.querySelectorAll('[data-max-selections]').forEach(function(el) {
                      el.setAttribute('data-max-selections', maxSelections);
                    });
                    fragment.appendChild(clone);
                    newCount++;
                  }
                });

                if (newCount > 0) {
                  container.appendChild(fragment);
                  syncProductListsWithCart();
                  applyStrengthFilters(blockId);
                  setItemsContainerMinHeight();
                }
              }

              // Decide whether to continue
              if (hasNoMorePages || !nextCollectionPage) {
                hasMoreProducts = false;
                container.dataset.complete = 'true';
              } else {
                currentPage = parseInt(nextCollectionPage);
                setTimeout(function() {
                  if (hasMoreProducts && !isLoading) loadMoreProducts();
                }, 300);
              }
            } catch (error) {
              console.error('[MCG Upsell Pagination] Error loading products:', error);
              hasMoreProducts = false;
              container.dataset.complete = 'true';
            } finally {
              isLoading = false;
              if (loadingIndicator) loadingIndicator.style.display = 'none';
            }
          };

          setTimeout(function() {
            if (hasMoreProducts && !isLoading) {
              loadMoreProducts();
            }
          }, 500);
        });
      }

      // Initialize on page load - fetch cart once and use for all initialization
      async function initOnPageLoad() {
        // Fetch cart data once for all initialization
        let cartData = null;
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart.js');
          cartData = await response.json();
        } catch (error) {
          console.error('Error fetching cart on page load:', error);
        }

        // Initialize loyalty products (just set up event listeners, don't fetch)
        initLoyaltyProducts();
        initMemberExclusiveProducts();

        // Sync all components with the fetched cart data (no additional fetches)
        if (cartData) {
          syncAllLoyaltyCards(cartData);
          syncAllMeCards(cartData);
          syncProductListsWithCart(cartData);
        } else {
          syncAllMeCards(null);
        }

        updateLoyaltyHeading();

        // Initialize auto-scrolling pagination for loyalty, base, and upsell products
        initMCGLoyaltyPagination();
        initMCGBasePagination();
        initMCGUpsellPagination();

        // Defensive: re-apply filters whenever new product cards are appended to any
        // base/upsell/loyalty container. The pagination loaders already call
        // applyStrengthFilters, but this guarantees correctness even if a card slips
        // through with a wrong/missing data-block-id.
        var filterableContainers = document.querySelectorAll(
          '.mcg-base-products[data-block-id], .mcg-upsell-products[data-block-id], .free-cans-products.minimised-loyalty-products[data-block-id]'
        );
        filterableContainers.forEach(function(container) {
          if (container.dataset.filterObserverAttached === 'true') return;
          container.dataset.filterObserverAttached = 'true';
          var blockId = container.getAttribute('data-block-id') || '';
          if (!blockId) return;
          var observer = new MutationObserver(function(mutations) {
            var added = false;
            for (var i = 0; i < mutations.length; i++) {
              if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
                added = true;
                break;
              }
            }
            if (!added) return;
            // Stamp block id on any new cards (and their descendants) that are
            // missing or have a different one, then re-apply the filter state.
            container.querySelectorAll('.minimised-grid-product-card').forEach(function(card) {
              if (card.getAttribute('data-block-id') !== blockId) {
                card.setAttribute('data-block-id', blockId);
              }
              card.querySelectorAll('[data-block-id]').forEach(function(el) {
                if (el.getAttribute('data-block-id') !== blockId) {
                  el.setAttribute('data-block-id', blockId);
                }
              });
            });
            applyStrengthFilters(blockId);
          });
          observer.observe(container, { childList: true, subtree: true });
        });

        // Set min-height after a short delay to ensure all content is loaded
        setTimeout(setItemsContainerMinHeight, 100);
        // Initialize filter navigation arrows
        setTimeout(initFilterNavigation, 100);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initOnPageLoad);
      } else {
        initOnPageLoad();
      }

      // Sync product list states with cart (for base and upsell blocks)
      async function syncProductListsWithCart(cartData = null) {
        // Debounce to prevent multiple rapid calls
        if (syncProductListsTimeout) {
          clearTimeout(syncProductListsTimeout);
        }

        return new Promise((resolve) => {
          syncProductListsTimeout = setTimeout(async () => {
            try {
              // Get current cart
              let cart = cartData;
              if (!cart) {
                if (window.MarketCartUtils) {
                  cart = await window.MarketCartUtils.getMarketAwareCartData(false);
                } else {
                  const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
                  cart = await cartResponse.json();
                }
              }

          if (!cart || !cart.items) {
            resolve();
            return;
          }

          // Get all variant IDs in cart for base blocks (excluding upsell items, quantity_restricted items, and free cans)
          const baseCartVariantIds = new Set();
          // Map variant ID -> quantity in cart (for base items)
          const baseCartVariantQty = {};
          // Get all variant IDs in cart for upsell blocks (including upsell items and quantity_restricted items, excluding free cans)
          const upsellCartVariantIds = new Set();

          cart.items.forEach(item => {
            // Skip free cans for both
            if (item.properties && item.properties._free_can === 'true') {
              return;
            }

            const variantId = String(item.variant_id);
            // Treat quantity_restricted items and checkout block upsells the same as upsell items for duplicate prevention
            const isUpsellOrRestricted = item.properties && (
              item.properties._upsell_item === 'true' ||
              item.properties._quantity_restricted === 'true' ||
              (item.properties._checkoutblocks && String(item.properties._checkoutblocks).includes('advanced-upsell'))
            );
            if (isUpsellOrRestricted) {
              // Add to upsell cart variant IDs
              upsellCartVariantIds.add(variantId);
            } else {
              // Add to base cart variant IDs
              baseCartVariantIds.add(variantId);
              baseCartVariantQty[variantId] = item.quantity;
            }
          });

          // Get all blocks (base and upsell)
          const allBlocks = new Set();
          document.querySelectorAll('.minimised-grid-buy-btn[data-block-id]').forEach(btn => {
            allBlocks.add(btn.getAttribute('data-block-id'));
          });

          // Update each block's state
          allBlocks.forEach(blockId => {
            const buttons = document.querySelectorAll('.minimised-grid-buy-btn[data-block-id="' + blockId + '"]');
            if (buttons.length === 0) return;

            // Check if this is an upsell block
            const isUpsellBlock = buttons[0].classList.contains('minimised-grid-upsell-btn');
            const cartVariantIds = isUpsellBlock ? upsellCartVariantIds : baseCartVariantIds;

            // Check if this is a base-can block
            const firstCard = buttons[0].closest('.minimised-grid-product-card');
            const isBaseCan = firstCard && firstCard.getAttribute('data-block-type') === 'base';

            // Get variants in cart for this block
            const blockVariantIds = [];
            buttons.forEach(btn => {
              const variantId = btn.getAttribute('data-variant-id');
              if (cartVariantIds.has(variantId)) {
                const productId = btn.getAttribute('data-product-id');
                blockVariantIds.push({ productId: productId, variantId: variantId });

                // For base-can blocks, sync the buyo qty display with cart quantity
                if (isBaseCan && baseCartVariantQty[variantId]) {
                  const cartQty = baseCartVariantQty[variantId];
                  btn.setAttribute('data-quantity', cartQty);
                  // Update the buyo container
                  const buyoEl = btn.closest('.mgrid-buyo');
                  if (buyoEl) {
                    buyoEl.setAttribute('data-quantity', cartQty);
                    const qtyEl = buyoEl.querySelector('.mgrid-buyo__qty');
                    if (qtyEl) qtyEl.textContent = 'x' + cartQty;
                    // Recalculate the price for this qty from price-per-q
                    const card = buyoEl.closest('.minimised-grid-product-card');
                    if (card) {
                      const tiers = parsePriceMapping(card.getAttribute('data-price-per-q'));
                      const moneyFmt = window.money_format;
                      // Find matching tier or closest
                      let matchedTier = tiers[0];
                      for (var ti = tiers.length - 1; ti >= 0; ti--) {
                        if (cartQty >= tiers[ti].qty) { matchedTier = tiers[ti]; break; }
                      }
                      if (matchedTier && matchedTier.qty === cartQty) {
                        const newPrice = formatMoney(matchedTier.price * 100, moneyFmt);
                        btn.setAttribute('data-original-price', newPrice);
                      }
                    }
                  }
                }
              }
            });

            // Update localStorage to match cart
            if (blockVariantIds.length > 0) {
              const selectionString = blockVariantIds.map(sel => sel.productId + '|' + sel.variantId).join(',');
              localStorage.setItem('minimised-grid-selection-' + blockId, selectionString);
            } else {
              localStorage.removeItem('minimised-grid-selection-' + blockId);
            }

            // Update button states
            updateBlockSelectionState(blockId, null);
          });

          // Update checkout button with cart data (don't fetch again)
          updateCheckoutButton(cart);
          resolve();
            } catch (error) {
              console.error('Error syncing product lists with cart:', error);
              resolve();
            }
          }, 100); // 100ms debounce
        });
      }

      // Debounce timeout for loyalty card sync
      let syncLoyaltyCardsTimeout = null;

      // Helper function to sync all loyalty card quantities with cart (debounced, single fetch)
      function syncAllLoyaltyCards(cartData = null) {
        // Clear any pending sync
        if (syncLoyaltyCardsTimeout) {
          clearTimeout(syncLoyaltyCardsTimeout);
        }

        syncLoyaltyCardsTimeout = setTimeout(async () => {
          try {
            // Use provided cart data or fetch once
            let cart = cartData;
            if (!cart) {
              const response = await fetch(window.Shopify.routes.root + 'cart.js');
              cart = await response.json();
            }

            // Update all loyalty cards with the same cart data
            const loyaltyCards = document.querySelectorAll('.minimised-loyalty-card');
            loyaltyCards.forEach(card => {
              updateLoyaltyCardFromCart(card, cart);
            });
            // Grey out loyalty cards when max free cans reached (mirrors free cans tab)
            updateLoyaltyCardOpacity(cart);
          } catch (error) {
            console.error('Error syncing loyalty cards:', error);
          }
        }, 100); // 100ms debounce
      }

      // Listen for cart updates from cart drawer and other sources
      document.addEventListener('on:cart:add', function(e) {
        const cartData = e.detail && e.detail.cart ? e.detail.cart : null;
        // Immediate update when items are added (same as progress bar)
        updateLoyaltyHeading();
        syncAllLoyaltyCards(cartData);
        syncAllMeCards(cartData);
        syncProductListsWithCart(cartData);
      });

      document.addEventListener('cart:updated', function(e) {
        const cartData = e.detail && e.detail.cart ? e.detail.cart : null;
        // Generic cart update event
        updateLoyaltyHeading();
        syncAllLoyaltyCards(cartData);
        syncAllMeCards(cartData);
        syncProductListsWithCart(cartData);
      });

      // Also listen for cart:refresh events
      document.addEventListener('cart:refresh', function(e) {
        const cartData = e.detail && e.detail.cart ? e.detail.cart : null;
        syncAllLoyaltyCards(cartData);
        syncAllMeCards(cartData);
        syncProductListsWithCart(cartData);
      });

      document.addEventListener('freeCans:productAdded', function(e) {
        const cartData = e.detail && e.detail.cart ? e.detail.cart : null;
        // Refresh all loyalty displays
        syncAllLoyaltyCards(cartData);
        syncAllMeCards(cartData);
        // Update heading
        updateLoyaltyHeading();
      });

      document.addEventListener('freeCans:productRemoved', function(e) {
        const cartData = e.detail && e.detail.cart ? e.detail.cart : null;
        // Refresh all loyalty displays
        syncAllLoyaltyCards(cartData);
        syncAllMeCards(cartData);
        // Update heading
        updateLoyaltyHeading();
      });

      // Update dynamic heading when free cans change
      function updateLoyaltyHeading () {

      }
      /*function updateLoyaltyHeading() {
        const stepAfters = document.querySelectorAll('.minimised-loyalty-dynamic-step-after');
        stepAfters.forEach(stepAfter => {
          const maxFreeCans = parseInt(stepAfter.dataset.maxFreeCans) || 0;

          // Don't update heading if user is logged out (maxFreeCans is 0)
          if (maxFreeCans <= 0) {
            return;
          }

          // Get current cart to calculate remaining using centralized service
          const getCart = async () => {
            if (window.MarketCartUtils) {
              return await window.MarketCartUtils.getMarketAwareCartData(false);
            } else {
              const response = await fetch(window.Shopify.routes.root + 'cart.js');
              return await response.json();
            }
          };

          getCart()
            .then(cart => {
              let freeCansCount = 0;
              cart.items.forEach(item => {
                if (item.properties && item.properties._free_can === 'true' &&
                    item.properties._free_can_type === 'bundle_product') {
                  freeCansCount += item.quantity;
                }
              });

              const remaining = maxFreeCans - freeCansCount;
              stepAfter.textContent = `Select ${remaining} Loyalty Cans`;
            })
            .catch(error => console.error('Error updating heading:', error));
        });
      }
      */

      // ── Qty/Price Combo (mgrid-buyo) for base cans ──

      // Close any open popup
      function closeMgridPopups() {
        document.querySelectorAll('.mgrid-buyo-popup').forEach(function(p) { p.remove(); });
        document.querySelectorAll('.mgrid-buyo.is-open').forEach(function(b) { b.classList.remove('is-open'); });
      }

      // Get total cans currently selected in a block
      function getBlockTotalCans(blockId) {
        var total = 0;
        document.querySelectorAll('.minimised-grid-product-card[data-block-id="' + blockId + '"][data-block-type="base"]').forEach(function(card) {
          var btn = card.querySelector('.mgrid-buyo__btn');
          if (btn && btn.classList.contains('minimised-grid-btn-selected')) {
            total += parseInt(btn.getAttribute('data-quantity'), 10) || 0;
          }
        });
        return total;
      }

      // Update all base-can buyo buttons' disabled state based on total cans capacity
      function updateBaseCansCapacity(blockId) {
        var maxCans = 0;
        var cards = document.querySelectorAll('.minimised-grid-product-card[data-block-id="' + blockId + '"][data-block-type="base"]');
        cards.forEach(function(card) { maxCans = parseInt(card.getAttribute('data-max-cans'), 10) || maxCans; });
        if (maxCans <= 0) return;

        var totalUsed = getBlockTotalCans(blockId);
        var remaining = maxCans - totalUsed;
        var moneyFmt = window.money_format;

        cards.forEach(function(card) {
          var btn = card.querySelector('.mgrid-buyo__btn');
          if (!btn) return;
          var isSelected = btn.classList.contains('minimised-grid-btn-selected');
          if (isSelected) {
            // Selected buttons stay enabled (for Remove)
            btn.disabled = false;
          } else {
            var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 0;
            if (remaining <= 0) {
              btn.disabled = true;
            } else if (qty > remaining) {
              // Try to auto-downsize to a tier that fits within remaining capacity
              var tiers = parsePriceMapping(card.getAttribute('data-price-per-q'));
              var fittingTier = null;
              // tiers are sorted by qty ascending - find the largest that fits
              for (var ti = tiers.length - 1; ti >= 0; ti--) {
                if (tiers[ti].qty <= remaining) {
                  fittingTier = tiers[ti];
                  break;
                }
              }
              if (fittingTier) {
                // Switch button to the fitting tier
                var newPrice = formatMoney(fittingTier.price * 100, moneyFmt);
                btn.setAttribute('data-quantity', fittingTier.qty);
                btn.setAttribute('data-original-price', newPrice);
                var textEl = btn.querySelector('.mgrid-btn-text');
                if (textEl) textEl.textContent = newPrice; else btn.textContent = newPrice;
                var buyoEl = btn.closest('.mgrid-buyo');
                if (buyoEl) {
                  buyoEl.setAttribute('data-quantity', fittingTier.qty);
                  var qtyEl = buyoEl.querySelector('.mgrid-buyo__qty');
                  if (qtyEl) qtyEl.textContent = 'x' + fittingTier.qty;
                }
                btn.disabled = false;
              } else {
                btn.disabled = true;
              }
            } else {
              btn.disabled = false;
            }
          }
        });
      }

      // Parse price mapping string into tiers array
      function parsePriceMapping(mappingStr) {
        if (!mappingStr) return [];
        return mappingStr.split(',').map(function(entry) {
          var parts = entry.split(':');
          return {
            qty: parseInt(parts[0]),
            price: parseFloat(parts[1]),
            comparePrice: parseFloat(parts[2])
          };
        }).sort(function(a, b) { return a.qty - b.qty; });
      }

      // Build and inject popup below a card
      function openMgridPopup(card, buyoEl) {
        closeMgridPopups();

        var priceMapping = card.getAttribute('data-price-per-q');
        var inventory = parseInt(card.getAttribute('data-inventory')) || 0;
        var blockId = card.getAttribute('data-block-id');
        var currentQty = parseInt(buyoEl.getAttribute('data-quantity'), 10) || 1;
        var tiers = parsePriceMapping(priceMapping);
        if (!tiers.length) return;

        // Calculate remaining capacity
        var maxCans = parseInt(card.getAttribute('data-max-cans'), 10) || 0;
        var totalUsed = getBlockTotalCans(blockId);
        var btn = buyoEl.querySelector('.mgrid-buyo__btn');
        var isSelected = btn && btn.classList.contains('minimised-grid-btn-selected');
        // If this row is already selected, its qty is already counted in totalUsed
        var ownQty = isSelected ? currentQty : 0;
        var remainingForOthers = maxCans > 0 ? (maxCans - totalUsed + ownQty) : Infinity;

        var moneyFmt = window.money_format;
        var variantId = card.getAttribute('data-variant-id');
        var uniqueId = 'mgrid-popup-' + variantId;

        var popup = document.createElement('div');
        popup.className = 'mgrid-buyo-popup';

        var table = '<table class="mgrid-buyo-popup__table"><thead><tr>' +
          '<th class="mgrid-buyo-popup__th mgrid-buyo-popup__th--qty">Qty</th>' +
          '<th class="mgrid-buyo-popup__th mgrid-buyo-popup__th--perpack">Per Pack</th>' +
          '<th class="mgrid-buyo-popup__th mgrid-buyo-popup__th--total">Total</th>' +
          '<th class="mgrid-buyo-popup__th mgrid-buyo-popup__th--radio">' +
            '<button type="button" class="mgrid-buyo-popup__sort-btn">' +
              '<svg class="mgrid-buyo-popup__chevron" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="#484848" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
          '</th>' +
          '</tr></thead><tbody>';

        tiers.forEach(function(tier, idx) {
          var isOos = tier.qty > inventory;
          var isOverCapacity = tier.qty > remainingForOthers;
          var unitPrice = tier.price / tier.qty;
          var totalPrice = tier.price;
          var perPackFmt = formatMoney(unitPrice * 100, moneyFmt);
          var totalFmt = formatMoney(totalPrice * 100, moneyFmt);
          var isChecked = tier.qty === currentQty;
          var radioId = uniqueId + '-' + idx;
          var rowClass = 'mgrid-buyo-popup__row';
          if (isOos) rowClass += ' is-oos';
          else if (isOverCapacity) rowClass += ' is-over-capacity';
          if (isChecked) rowClass += ' is-selected';

          table += '<tr class="' + rowClass + '" data-qty="' + tier.qty + '" data-total-price="' + totalPrice + '">' +
            '<td class="mgrid-buyo-popup__td mgrid-buyo-popup__td--qty"><span class="mgrid-buyo-popup__qty-badge">x' + tier.qty + '</span></td>' +
            '<td class="mgrid-buyo-popup__td mgrid-buyo-popup__td--perpack"><span>' + perPackFmt + '</span></td>' +
            '<td class="mgrid-buyo-popup__td mgrid-buyo-popup__td--total"><span>' + totalFmt + '</span></td>' +
            '<td class="mgrid-buyo-popup__td mgrid-buyo-popup__td--radio">' +
              '<input type="radio" class="mgrid-buyo-popup__radio" name="' + uniqueId + '" id="' + radioId + '" value="' + tier.qty + '"' + (isChecked ? ' checked' : '') + '>' +
              '<label class="mgrid-buyo-popup__radio-label" for="' + radioId + '"></label>' +
            '</td>' +
          '</tr>';
        });

        table += '</tbody></table>';
        popup.innerHTML = table;

        // Insert after the card
        card.after(popup);
        buyoEl.classList.add('is-open');

        // Row click handler — select tier
        popup.querySelectorAll('.mgrid-buyo-popup__row').forEach(function(row) {
          if (row.classList.contains('is-oos') || row.classList.contains('is-over-capacity')) return;
          row.addEventListener('click', function() {
            var tierQty = parseInt(row.dataset.qty);
            var tierTotalPrice = parseFloat(row.dataset.totalPrice);
            var totalFmt = formatMoney(tierTotalPrice * 100, moneyFmt);

            // Update buyo bar
            buyoEl.setAttribute('data-quantity', tierQty);
            buyoEl.querySelector('.mgrid-buyo__qty').textContent = 'x' + tierQty;
            var buyoBtn = buyoEl.querySelector('.mgrid-buyo__btn');
            if (buyoBtn) {
              buyoBtn.setAttribute('data-quantity', tierQty);
              buyoBtn.setAttribute('data-original-price', totalFmt);
              // Only update text if not in "Remove" state
              if (!buyoBtn.classList.contains('minimised-grid-btn-selected')) {
                buyoBtn.textContent = totalFmt;
              }
            }

            // If already in cart, update the cart quantity
            if (buyoBtn && buyoBtn.classList.contains('minimised-grid-btn-selected')) {
              updateCartItemQty(buyoBtn, tierQty, totalFmt);
            }

            closeMgridPopups();
          });
        });

        // Sort button
        var sortBtn = popup.querySelector('.mgrid-buyo-popup__sort-btn');
        if (sortBtn) {
          sortBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            sortBtn.classList.toggle('is-reversed');
            var tbody = popup.querySelector('tbody');
            var rows = Array.from(tbody.querySelectorAll('tr'));
            rows.reverse().forEach(function(r) { tbody.appendChild(r); });
          });
        }
      }

      // Update cart item quantity when user changes qty on an already-added row
      async function updateCartItemQty(btn, newQty, newPriceFmt) {
        var cartScriptsReady = window.loadCartDrawerScripts
          ? window.loadCartDrawerScripts()
          : Promise.resolve();
        var variantId = btn.getAttribute('data-variant-id');
        var blockId = btn.getAttribute('data-block-id');

        btn.classList.add('minimised-grid-btn-loading');
        btn.disabled = true;

        try {
          var cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
          var cart = await cartResponse.json();

          // Find the base line item for this variant
          var lineItem = cart.items.find(function(item) {
            if (String(item.variant_id) !== String(variantId)) return false;
            if (item.properties) {
              if (item.properties._upsell_item === 'true' || item.properties._quantity_restricted === 'true') return false;
            }
            return true;
          });

          if (!lineItem) {
            btn.classList.remove('minimised-grid-btn-loading');
            btn.disabled = false;
            return;
          }

          var cartDrawer = document.getElementById('cart-drawer');
          var sections = 'cart-icon-bubble';
          if (cartDrawer) {
            var cartDrawerSection = cartDrawer.closest('.shopify-section');
            if (cartDrawerSection) sections += ',' + cartDrawerSection.id.replace('shopify-section-', '');
          }

          var response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              id: lineItem.key,
              quantity: newQty,
              sections: sections,
              sections_url: window.location.pathname + window.location.search
            })
          });

          var data = await response.json();

          // Update price display
          btn.setAttribute('data-original-price', newPriceFmt);

          // Dispatch cart events
          if (data && data.items !== undefined) {
            if (window.MarketCartUtils && window.MarketCartUtils.setEventCartData) {
              window.MarketCartUtils.setEventCartData(data);
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: data } }));
          }

          if (data.sections && data.sections['cart-icon-bubble']) {
            if (window.MarketCartUtils && window.MarketCartUtils.updateCartIconBubble) {
              window.MarketCartUtils.updateCartIconBubble(data.sections['cart-icon-bubble']);
            }
          }

          var cartDrawerEl = document.getElementById('cart-drawer');
          if (cartDrawerEl && data.sections) {
            cartScriptsReady
              .then(function () {
                if (typeof cartDrawerEl.renderContents === 'function') {
                  return cartDrawerEl.renderContents(data, false);
                }
              })
              .catch(function (err) { console.error('Error updating cart drawer:', err); });
          }

          // Update capacity for the block
          updateBaseCansCapacity(blockId);

        } catch (err) {
          console.error('Error updating cart item qty:', err);
        } finally {
          btn.classList.remove('minimised-grid-btn-loading');
          btn.disabled = false;
        }
      }

      // Handle buyo left click (dropdown toggle)
      document.addEventListener('click', function(e) {
        var leftEl = e.target.closest('.mgrid-buyo__left');
        if (leftEl) {
          e.preventDefault();
          e.stopPropagation();
          var buyoEl = leftEl.closest('.mgrid-buyo');
          var card = buyoEl.closest('.minimised-grid-product-card');
          if (!card) return;

          var isOpen = buyoEl.classList.contains('is-open');
          if (isOpen) {
            closeMgridPopups();
          } else {
            openMgridPopup(card, buyoEl);
          }
          return;
        }

        // Close popups on any outside click
        if (!e.target.closest('.mgrid-buyo-popup') && !e.target.closest('.mgrid-buyo__left')) {
          closeMgridPopups();
        }
      });

      // After add/remove, update capacity for base-can blocks
      document.addEventListener('cart:updated', function() {
        // Re-evaluate capacity for all base-can blocks
        var seenBlocks = {};
        document.querySelectorAll('.minimised-grid-product-card[data-block-type="base"]').forEach(function(card) {
          var blockId = card.getAttribute('data-block-id');
          if (!seenBlocks[blockId]) {
            seenBlocks[blockId] = true;
            updateBaseCansCapacity(blockId);
          }
        });
      });

    })();
